// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__tWuWY","description":"PatientConsentPreview_description__3yE6l"};